import { WbMarkdownHelperText } from '@agilelab/plugin-wb-platform';
import { FormControl, FormHelperText, List, ListItem } from '@material-ui/core';
import { FieldTemplateProps } from '@rjsf/utils';
import { FunctionComponent, JSXElementConstructor, ReactElement } from 'react';
import WrapIfAdditional from './WrapIfAdditional';

export interface DefaultFieldTemplateProps extends FieldTemplateProps {
  DescriptionField: FunctionComponent<{
    id: string;
    description:
      | string
      | ReactElement<any, string | JSXElementConstructor<any>>;
  }>;
}

export const DefaultFieldTemplate = (props: FieldTemplateProps) => {
  const {
    id,
    children,
    classNames,
    disabled,
    displayLabel,
    hidden,
    label,
    onDropPropertyClick,
    onKeyChange,
    readonly,
    required,
    rawErrors = [],
    rawHelp,
    rawDescription,
    schema,
  } = props;

  if (hidden) {
    return children;
  }

  return (
    <WrapIfAdditional
      classNames={classNames ?? ''}
      disabled={disabled}
      id={id}
      label={label}
      onDropPropertyClick={onDropPropertyClick}
      onKeyChange={onKeyChange}
      readonly={readonly}
      required={required ?? false}
      schema={schema}
    >
      <FormControl fullWidth error={rawErrors.length > 0} required={required}>
        {children}
        {displayLabel && rawDescription && (
          <WbMarkdownHelperText helperText={rawDescription} />
        )}
        {rawErrors.length > 0 && (
          <List dense disablePadding>
            {rawErrors.map((error, i: number) => {
              return (
                <ListItem key={i} disableGutters>
                  <FormHelperText>{error}</FormHelperText>
                </ListItem>
              );
            })}
          </List>
        )}
        {rawHelp && <FormHelperText>{rawHelp}</FormHelperText>}
      </FormControl>
    </WrapIfAdditional>
  );
};

export default DefaultFieldTemplate;
